<template>
  <div>

    <!-- === Data table === -->
      <v-card>
        <v-card-title>
          <v-btn rounded class="mr-5" depressed color="primary" @click="handleAdd()">
            <v-icon class="mr-1" dark>
              mdi-plus-circle
            </v-icon>
            {{ $t("addNew") }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="productListSetting"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
        >
          <!-- Progressive -->
          <template v-slot:progress><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.image="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.sku="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.product_type="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.category_name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.unit="{ header }">{{ header.text }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <!-- Body -->
          <template v-slot:item.image="{ item }"><v-avatar tile size="45"><img :src="item.image" alt=""></v-avatar></template>
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" outlined class="table-action-button mr-2" text icon @click="handleEdit(item, $event)">
              <font-awesome-icon icon="edit"/>
            </v-btn>
            <!-- <v-btn color="error" outlined class="table-action-button" text icon
                  @click.native="handleRemove(item)">
              <font-awesome-icon icon="trash"/>
            </v-btn> -->
          </template>
        </v-data-table>

        <!-- Pagination -->
        <div class="text-center pt-2">
          <v-card-actions>
            <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly"><v-select :label="$t('perPage')" v-model="itemsPerPage" :items="pageList"></v-select></v-col>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
            ></v-pagination>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
              <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
              ></v-text-field>
            </v-col>
          </v-card-actions>
        </div>
      </v-card>
    <!-- === End Data table === -->

     <!--=== Form Product dialog section ==== -->
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addProduct") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editProduct") }}</span>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              icon
              @click="handleClose()"
              valid="false"
              v-shortkey="['esc']"
              @shortkey.native="handleClose()"
            >
            <span class="white--text">
              <v-icon dark>mdi-close</v-icon>
            </span>
            </v-btn>
          
            </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="formProduct">
                  <v-container fluid>
                    <v-row :no-gutters="$vuetify.breakpoint.mobile">
                      <v-col cols="12" xl="9" lg="9" md="9">
                          <v-row :no-gutters="$vuetify.breakpoint.mobile">
                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-autocomplete
                                  v-model="formDoc.product_type"
                                  :items="parentCategories"
                                  item-name="product_type"
                                  item-value="product_type"
                                  outlined
                                  :dense="dense"
                                  :label="$t('productType') + '*'"
                                  :rules="selectRules"
                                  required
                                  clearable
                                >
                              <template v-slot:item="{item}">{{$t(item.product_type)}}</template>
                              <template v-slot:selection="{item}">{{$t(item.product_type)}}</template>
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                                <v-autocomplete
                                    v-model="formDoc.category_id"
                                    :items="childCategories"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                                    :dense="dense"
                                    :label="$t('category') + '*'"
                                    :rules="selectRules"
                                    required
                                    clearable
                                  >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-autocomplete
                                  v-model="formDoc.sub_category_id"
                                  :items="grandChildCategories"
                                  item-text="name"
                                  item-value="id"
                                  outlined
                                  :dense="dense"
                                  :label="$t('subCategory')"
                                  clearable
                                >
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-text-field
                                  v-model="formDoc.sku"
                                  :label="$t('code') + '*'"
                                  :rules="valueRules"
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>

                             <v-col cols="12" xl="4" lg="4" md="4">
                              <v-text-field
                                  v-model="formDoc.name"
                                  :label="$t('name') + '*'"
                                  :rules="valueRules"
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-text-field
                                  dense
                                  outlined
                                  v-model="formDoc.tax"
                                  :rules="numberRules"
                                  requeired
                                  :suffix="'%'"
                                  :label="$t('tax')">
                                  <template slot="prepend">
                                     <v-select
                                      style="margin-top: -7px"
                                      dense
                                      outlined
                                        v-model="formDoc.tax_type"
                                        :items="['inclusive', 'exclusive']"
                                      >
                                        <template v-slot:item="{item}">{{$t(item)}}</template>
                                        <template v-slot:selection="{item}">{{$t(item)}}</template>
                                      </v-select>
                                  </template>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-autocomplete
                                  v-model="formDoc.unit_id"
                                  :items="listUnits"
                                  item-text="actual_name"
                                  item-value="id"
                                  :rules="valueRules"
                                  required
                                  outlined
                                  :dense="dense"
                                  :label="$t('unit') + '*'"
                                >
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-text-field
                                  dense
                                  outlined
                                  v-model="formDoc.base_unit"
                                  :rules="requireAndNumber"
                                  required
                                  :label="$t('baseUnit')">
                                  <template slot="append-outer">
                                     <v-select
                                      style="margin-top: -7px"
                                      dense
                                      outlined
                                        v-model="formDoc.base_unit_id"
                                        :items="listUnits"
                                        item-text="actual_name"
                                        item-value="id"
                                      >
                                      </v-select>
                                  </template>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-autocomplete
                                  v-model="formDoc.enable_stock"
                                  :items="[{value: 0, label: 'no'}, {value: 1, label: 'yes'}]"
                                  item-text="label"
                                  item-value="value"
                                  :rules="valueRules"
                                  required
                                  outlined
                                  :dense="dense"
                                  :label="$t('enableStock') + '*'"
                                >
                                <template v-slot:item="{item}">{{$t(item.label)}}</template>
                                <template v-slot:selection="{item}">{{$t(item.label)}}</template>
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xl="4" lg="4" md="4">
                              <v-text-field
                                  v-model="formDoc.alert_quantity"
                                  :label="$t('alertQuantity') + '*'"
                                  :rules="requireAndNumber"
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                              <v-textarea
                                  v-model="formDoc.product_description"
                                  outlined
                                  :label="$t('description')"
                                  rows="3"
                                ></v-textarea>
                            </v-col>
                          </v-row>
                      </v-col>

                      <v-col cols="1"></v-col>

                      <v-col cols="12" xl="2" lg="2" md="2">
                        <v-row>
                            <v-col cols="12">

                              <v-img
                                :src="preview_avatar"
                                aspect-ratio="1"
                                class="grey lighten-2 avatar-container"
                                max-height="200"
                              >
                                <button type="button" class="remove-avatar" @click="removeFileUpload(formDoc.image)">x</button>
                              </v-img>
                              
                              <span class="red--text"  v-if="avatar_msg" v-html="avatar_msg"></span>

                              <label id="avatar" style="cursor:pointer" max-width="250"> {{ $t('upload') }}
                                <input type="file" size="60"
                                  @change="upload_avatar"
                                >
                              </label> 


                            </v-col>
                        </v-row>

                      </v-col>
                    </v-row>
                   
                  </v-container>
                </v-form>
              </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" outlined text @click="dialog = false">
                {{ $t('close') }}
              </v-btn>
              <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
                <font-awesome-icon icon="check-circle" class="mr-1"/>
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    <!--=== End Form Product dialog section ==== -->

    

  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";
import _ from "lodash";
import { uploadFile, removeFile } from '../../../helpers';

export default {
  name: "Product",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      headers: [
        {
          text: "image",
          value: "image",
          sortable: false,
          align: "center",
        },
        { 
          text: "code",
          value: "sku",
          sortable: true,
          align: "center", 
        },
        { 
          text: "name", 
          value: "name",
          sortable: true,
          align: "left", 
        },
        { 
          text: "type", 
          value: "product_type",
          sortable: true,
          align: "center", 
        },
        { 
          text: "category", 
          value: "category_name",
          sortable: true,
          align: "center", 
        },
        { 
          text: this.$t("unit"), 
          value: "unit_name",
          sortable: true,
          align: "center", 
        },
        { text: "action", value: "action", sortable: false, width: 115 }
      ],
      preview_avatar: '',
      avatar_msg: '',
      old_image: '',

      formDoc: {
        id                  : "",
        image               : "",
        sku                 : "",
        name                : "",
        product_type        : "",
        category_id         : "",
        sub_category_id     : "",
        unit_id             : "1",
        base_unit           : "",
        base_unit_id        : "1",
        product_description : "",
        product_note        : '',
        tax_type            : 'inclusive',
        tax                 : '',
        enable_stock        : 1,
        alert_quantity      : '',
        is_inactive         : '1'
      },

    };
  },
  mounted() {},
  methods: {
    reset() {
      let vm = this;
      if (vm.$refs.formProduct) {
          vm.$refs.formProduct.resetValidation();
          vm.formDoc.id                 = "";
          vm.formDoc.image              = "";
          vm.formDoc.sku                = "";
          vm.formDoc.name               = "";
          vm.formDoc.product_type       = "";
          vm.formDoc.category_id        = "";
          vm.formDoc.sub_category_id    = "";
          vm.formDoc.unit_id            = "1";
          vm.formDoc.base_unit          = "";
          vm.formDoc.base_unit_id       = "1";
          vm.formDoc.product_description= "";
          vm.formDoc.product_note       = "";
          vm.formDoc.tax_type           = "inclusive";
          vm.formDoc.tax                = "";
          vm.formDoc.enable_stock       = 1;
          vm.formDoc.alert_quantity     = "";
          vm.formDoc.is_inactive        = "1";
          vm.preview_avatar             = "";
          vm.avatar_msg                 = "";
      }
    },

    handleAdd() {
      let vm        = this;
      vm.dialog     = true;
      vm.toggleAdd  = true;
      vm.reset();
    },

    handleClose() {
        this.dialog = false;
        this.reset();
        this.fetchDataTable();
    },

    handleRemove(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.id + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.removeTransaction(item.id);
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    removeTransaction(id) {
      let vm = this;
      let url = provider.baseURL + provider.destroyProduct;
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },

    handleEdit(item, event) {
      event.preventDefault();
      let vm        = this;
      vm.overlay    = true;
      vm.dialog     = true;
      vm.toggleAdd  = false;
    
    if(Object.keys(item).length){
        vm.formDoc.id           = item.id; 
        vm.formDoc.image        = item.image;
        vm.formDoc.sku          = item.sku;
        vm.formDoc.name         = item.name;
        vm.formDoc.product_type = item.product_type;
        vm.formDoc.category_id  = item.category_id;
        vm.formDoc.unit_id      = item.unit_id;
        vm.formDoc.base_unit    = item.base_unit;
        vm.formDoc.base_unit_id = item.base_unit_id;
        vm.formDoc.product_description  = item.product_description;
        vm.formDoc.product_note = item.product_note;
        vm.formDoc.tax_type     = item.tax_type;
        vm.formDoc.tax          = item.tax;
        vm.preview_avatar       = item.image;
      }
    },

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchProductSetting({
        id: "",
        search: vm.search,
        category_id: '',
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 :1
      });

    }, 350),

    submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formProduct.validate()) {
          vm.overlay = true;

          let url = provider.baseURL + provider.storeProductSetting;

          return new Promise((resolve, reject) => {
              axios.post(url, this.formDoc, {headers: {
                Authorization: localStorage.token,
                "Content-Type": "multipart/form-data"
                }}).then(
                  res => {
                      if (res.data.response && res.data.response.code === 200) {
                          vm.$notify({
                              title: "Success",
                              message: vm.$t("success"),
                              type: "success",
                              duration: 700
                          });
                          vm.dialog   = false;
                          vm.fetchDataTable();
                          vm.overlay=false;
                      }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    },

    upload_avatar(event) {
       /**
         * splite extension to check validation
         */
        var json_img        = event.target.files[0];
        var split           = json_img.type.split("/");

        if (split[0] == "image") {

          var reader        = new FileReader();
          var img           = new Image();

          reader.onload     = e => {
            /**
             * declear varable of scope
             */
            var vm            = this;
            vm.preview_avatar = e.target.result;
            
             /**
             * Dimention of image with * height
             */
            img.onload        = function() { vm.avatar_msg = ""; };
            img.src           = reader.result;
          };

          reader.readAsDataURL(json_img);
          event.target.value = '';

          /**upload to firebase */
          let that = this;
          let uploadTask = uploadFile(json_img);
            uploadTask.on('state_changed', function(){
            }, function() { //*note upploadTask multiple work wait untile complete
            }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                  if(that.old_image){
                    removeFile(that.old_image);
                  }
                  that.old_image = downloadURL;
                  that.formDoc.image = downloadURL;
                });
            });
        }
        else {
          this.formDoc.image   = "";
          this.preview_avatar = "";
          this.avatar_msg     = "Allow only png, jpeg, jpg, gif.";
        }
      },

      removeFileUpload(url){
        if(url){
          removeFile(url);
          this.preview_avatar = "";
          this.formDoc.image  = "";
          this.old_image      = "";
        }
      },

  },
  created() {
    this.fetchDataTable();
  },
  computed:{},
  watch: {
    search() {
      this.fetchDataTable();
    },
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    "formDoc.category_id"(val){
      if(val){
        this.fetchGrandChildCategory({productType: this.formDoc.product_type, parent_id: val})
      }
    },
    "formDoc.product_type"(val){
      if(val){
        this.fetchChildCategory({productType: val})
      }
    },

    dialog(val){
      if(val){
        this.fetchParentCategory();
        this.fetchTransactionUnit({search: '', limit: this.noLimit, offset: this.currentPage});
      }
    }
  }
  
};
</script>